import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you shortly.');
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };
  
  // Define bubble properties (size, left position, and animation delay)
  const bubbles = [
    { size: '40px', left: '10%', delay: '0s' },
    { size: '60px', left: '25%', delay: '2s' },
    { size: '30px', left: '50%', delay: '4s' },
    { size: '50px', left: '70%', delay: '1s' },
    { size: '80px', left: '85%', delay: '3s' },
    { size: '30px', left: '40%', delay: '5s' },
    { size: '50px', left: '15%', delay: '6s' },
  ];

  return (
    <>
      <title>Contact Us | Arktemis</title>
      <meta name="description" content="Contact Arktemis to learn more about our sustainability and agricultural solutions. We are here to help you with your needs." />
      <link rel="canonical" href="https://arktemis.com/contact" />
      <div className="relative min-h-screen bg-black text-white overflow-hidden pt-20 py-12">
        {/* Background Bubble Animation */}
        <div className="absolute inset-0">
          {bubbles.map((bubble, index) => (
            <div
              key={index}
              className="bubble"
              style={{
                width: bubble.size,
                height: bubble.size,
                left: bubble.left,
                animationDelay: bubble.delay,
              }}
            ></div>
          ))}
        </div>

        {/* Contact Content */}
        <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center py-12">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-8 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent leading-tight" data-aos="fade-down">Get in Touch</h1>
          <p className="text-xl md:text-2xl mb-12 max-w-3xl leading-relaxed text-gray-300" data-aos="fade-up">
            Join us in our journey towards sustainability. We're eager to discuss your needs and explore how Arktemis can help.
          </p>
          
          {/* Contact Form */}
          <div className="w-full max-w-2xl bg-black-900 p-8 rounded-xl shadow-lg border border-gray-700" data-aos="fade-up">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-left text-lg font-semibold mb-2">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-left text-lg font-semibold mb-2">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-left text-lg font-semibold mb-2">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                ></textarea>
              </div>
              <button
                type="submit"
                className="relative w-full inline-flex items-center justify-center p-1 overflow-hidden text-lg font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 transition-all duration-300 ease-in-out transform hover:scale-105 active:scale-95"
              >
                <span className="relative w-full px-6 py-3 transition-all ease-in duration-150 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                  Send Message
                </span>
              </button>
            </form>
          </div>

          <div className="space-y-8 text-lg md:text-xl max-w-xl w-full mt-12" data-aos="fade-up">
            <div className="bg-black-900 p-6 rounded-xl shadow-lg border border-gray-700">
              <span className="font-bold text-blue-400">Connect: </span>
              <a href="https://www.linkedin.com/company/arktemis-group/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 underline mx-2 transition-all duration-300 transform hover:scale-110 inline-block">LinkedIn</a> |
              <a href="https://www.instagram.com/arktemisfoundation?igsh=MTQwcDJhczRwM216" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 underline mx-2 transition-all duration-300 transform hover:scale-110 inline-block">Instagram</a> |
              <a href="mailto:contact@arktemis.com" className="text-white hover:text-blue-400 underline mx-2 transition-all duration-300 transform hover:scale-110 inline-block">Get in touch</a>
            </div>
            <div className="bg-black-900 p-6 rounded-xl shadow-lg border border-gray-700">
              <span className="font-bold text-blue-400">Phone: </span>
              <a href="tel:+917498916438" className="text-white hover:text-blue-400 underline mx-2 transition-all duration-300 transform hover:scale-110 inline-block">+91 74989 16438</a> |
              <a href="tel:+918856918608" className="text-white hover:text-blue-400 underline mx-2 transition-all duration-300 transform hover:scale-110 inline-block">+91 88569 18608</a>
            </div>
            <div className="bg-black-900 p-6 rounded-xl shadow-lg border border-gray-700">
              <span className="font-bold text-blue-400">Email: </span>
              <a href="mailto:contact@arktemis.com" className="text-white hover:text-blue-400 underline transition-all duration-300 transform hover:scale-110 inline-block">contact@arktemis.com</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;